import { States } from '../../app.router';

/* @ngInject */
export default function orgDevicesRouter($stateProvider) {
    $stateProvider
        .state(States.ORGANIZATION_DEVICES, {
            url: '/organization-devices?{projectLabels:json}', // Optional { key: value } to preselect in the project labels filter
            views: {
                'content@main': {
                    component: 'dtOrganizationDevicesPage'
                }
            },
            data: {
                title: 'Organization Devices'
            }
        });
}
